(() => {
  return environments = [
    { // Development US
      match: '.devenv.us.printix.net',
      authDomain: 'auth.devenv.us.printix.net',
      apiDomain: 'api.devenv.us.printix.net'
    },
    { // Testing US
      match: '.testenv.us.printix.net',
      authDomain: 'auth.testenv.us.printix.net',
      apiDomain: 'api.testenv.us.printix.net'
    },
    { // Production US
      match: '.us.printix.net',
      authDomain: 'auth.us.printix.net',
      apiDomain: 'api.us.printix.net'
    },
    { // Development EU
      match: '.devenv.printix.net',
      authDomain: 'auth.devenv.printix.net',
      apiDomain: 'api.devenv.printix.net'
    },
    { // Testing EU
      match: '.testenv.printix.net',
      authDomain: 'auth.testenv.printix.net',
      apiDomain: 'api.testenv.printix.net'
    },
    { // Production EU
      match: '.printix.net',
      authDomain: 'auth.printix.net',
      apiDomain: 'api.printix.net'
    },
    { // Dev01 on kofaxtst.onmicrosoft.com
      match: '.dev01.printix.dev',
      authDomain: 'auth.dev01.printix.dev',
      apiDomain: 'api.dev01.printix.dev'
    },
    { // PIB sandbox
      match: '.PIB_DOMAIN',
      authDomain: 'auth.PIB_DOMAIN',
      apiDomain: 'api.PIB_DOMAIN',
      partnerPortal: 'https://partners.PIB_DOMAIN'
    }
  ];
})();
